'use strict';

var React = require('react');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const GridItem = ({ className = '', defaultSize, desktopSize, tabletSize, largeMobileSize, mobileSize, children, itemStyles = {}, rowMarginBottom = '' }) => {
    const columnSizes = clsx__default['default'](defaultSize && `col-xs-${defaultSize}`, mobileSize && `col-xs-${mobileSize}`, largeMobileSize && `col-sm-${largeMobileSize}`, tabletSize && `col-md-${tabletSize}`, desktopSize && `col-lg-${desktopSize}`);
    return (React__default['default'].createElement("div", { className: `${columnSizes} grid-column`, "data-testid": "grid-column" },
        React__default['default'].createElement("div", { className: clsx__default['default'](className, 'grid-item'), style: Object.assign({ marginBottom: rowMarginBottom }, itemStyles) }, children)));
};

module.exports = GridItem;
